import React from 'react';
import { useActivation } from '@context/MobileOne';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appIconsPath, appLinkStyle, appLinkSize } from '@utils/globalConstant';
import { Ta11yText, Link } from '@core/index';

// This button is reused in multiple pages and always has the same cms key
export const ButtonCancelActivation = () => {
  const { setShowActivationCancelModal } = useActivation();

  return (
    <>
      <Link
        iconRight={appIconsPath.CLOSE}
        linkStyle={appLinkStyle.PRIMARY}
        linkSize={appLinkSize.DEFAULT}
        onClick={() => setShowActivationCancelModal(true)}>
        <Ta11yText textContent={tA11y('ek_reg_cncl_link1')} tag="span" />
      </Link>
    </>
  );
};

export default ButtonCancelActivation;
